module.exports = __webpack_public_path__ + "static/media/p.3369b26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/p.png
// module id = 129
// module chunks = 0